<template>
  <div class="card">
    <div class="card-header"><h2 style="font-size: 20px;">Order Summary</h2></div>
    <div class="card-body">
      <b-row>
        <b-col cols="8">
          <b-row>
            <b-col>
              <div class="card">
                <div class="card-header">Products</div>
                <div class="card-body">
                  <b-row>
                    <b-col class="font-weight-bold">Product Line Item</b-col>
                    <b-col class="font-weight-bold">Record Subject Name</b-col>
                    <b-col class="font-weight-bold">Quantity Ordered</b-col>
                    <b-col class="font-weight-bold">Product Fee</b-col>
                  </b-row>
                  <b-card-group v-for="(orderProduct, index) in order.orderProducts" :key="index">
                    <b-card>
                      <b-row>
                        <b-col>
                          {{orderProduct.product?.name}}
                        </b-col>
                        <b-col>
                          {{orderProduct.subjectNameOrYear}}
                        </b-col>
                        <b-col v-if="limitedService.isLimited(orderProduct.product?.category, orderProduct.product?.code)">
                          <BaseTextInput v-model="orderProduct.quantity"
                                         label="Quantity To Order"
                                         slug="quantity"
                                         setId="quantityToOrder"
                                         :v="$v.order.orderProducts.$each[index].quantity"
                                         type="number"
                                         :min="0" :max="1"
                                         @input="recalculateFee(orderProduct.id, orderProduct.quantity)"
                          ></BaseTextInput>
                        </b-col>
                        <b-col v-else>
                          <BaseTextInput v-model="orderProduct.quantity"
                                         label="Quantity To Order"
                                         slug="quantity"
                                         setId="quantityToOrder"
                                         :v="$v.order.orderProducts.$each[index].quantity"
                                         type="number"
                                         :min="0"
                                         @input="recalculateFee(orderProduct.id, orderProduct.quantity)"
                          ></BaseTextInput>
                        </b-col>
                        <b-col>
                          ${{orderProduct.fee?.amount}}
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-card-group>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="card">
                <div class="card-header">Expedite</div>
                <div class="card-body">
                  <b-row class="mt-3">
                    <b-col>
                      <b-form-checkbox
                          size="md"
                          v-model="order.expedited"
                          class="font-weight-bold"
                          @change="updateExpedite()">
                        Expedite Order
                      </b-form-checkbox>
                    </b-col>
                    <b-col cols="8">
                      We will process your request in the order it is received. If you want us to handle your order ahead of other requests, select expedited processing.
                      Expedited processing does not include express delivery (rush shipping). Check our processing times to estimate how long it will take to get your order.
                      <br><br>
                      Expedite moves your order ahead of others so that your order is processed faster. Expedite does not ship or mail your order faster.
                      An expedite fee will be charged for each product included in the order. Order products separately if you do not need all products expedited.
                      <br><br>
                      Expediting your order will move it ahead of all non-expedited orders for processing.

                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
          <OrderReviewReadonly :order="order" :profile="profile" :attachments="attachments" :readonly="false"
                               v-on:change-tab="handleTabChange"/>

        </b-col>

        <b-col cols="4">
          <div class="card">
            <div class="card-header">Total</div>
            <div class="card-body">
              <b-row>
                <b-col>
                  Product Total
                </b-col>
                <b-col offset="4">
                  ${{totalProductFee(order)}}
                </b-col>
              </b-row>
              <b-row v-for="(fee, index) in order.nonProductFees" :key="index">
                <b-col>
                  {{fee?.feeType?.description}}
                </b-col>
                <b-col offset="4">
                  ${{fee.amount}}
                </b-col>
              </b-row>
              <b-row class="border-top mt-2 pt-2 font-weight-bold">
                <b-col offset="4">
                  Total:
                </b-col>
                <b-col>
                  ${{totalFee(order)}}
                </b-col>
              </b-row>
              <b-card class="border-danger mt-3">
                <b-row>
                  <b-col>
                    <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
                    A service fee will be charged for all orders at time of payment.
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>

</template>
<script>


import axiosRetry from 'axios-retry'
import axios from "axios"
import LocalStorageService from "@/common/LocalStorageService";
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import {minValue, required} from "vuelidate/lib/validators";
import OrderReviewReadonly from "@/components/checkout-wizard/OrderReviewReadonly.vue";
import {totalService} from "@/mixins/totalService";
import {limitedService} from "@/mixins/limitedService";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  });

const localStorageService = LocalStorageService.getService();


export default {
  computed: {
    limitedService() {
      return limitedService
    }
  },
  components: {OrderReviewReadonly, BaseTextInput},
  data: () => {
    return {
    }
  },
  props: {
    order: [Object],
    profile: [Object],
    attachments: [Array],
    requiresNotary: [Boolean],
    requiresDocuments: [Boolean],
  },
  mounted() {
  },
  mixins: [
    totalService,
    limitedService
  ],
  methods: {
    updateExpedite(){
      const payload = {
        id: localStorageService.getOrderNumber(),
        expedited: this.order.expedited
      }
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/order/expedite`, payload)
              .then(response=>{
                this.$emit("load-order")
              })
    },
    recalculateFee(product, quantity) {
      let payload = {
        id: product,
        quantity: quantity
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/order/quantity`, payload)
          .then(response=>{
            if (quantity === "0") {
              const idx = this.order.orderProducts.findIndex(p => p.id === product)
              this.order.orderProducts[idx].fee = { amount : 0 }
            } else {
              const idx = this.order.orderProducts.findIndex(p => p.id === product)
              this.order.orderProducts[idx].fee = response.data
            }
          })
      this.updateExpedite()
    },
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid, 'summary')
      return isValid
    },
    handleTabChange(tab) {
      this.$emit('change-tab', tab)
    },
  },

  validations() {
    return {
      order: {
        required: false,
        orderProducts: {
          required: false,
          $each: {
            quantity: { required, minValue: minValue(0), maxValue: function(value, parent) {
                return (!limitedService.isLimited(parent?.product?.category, parent?.product?.code) || value <= 1);
              }
            }
          }
        }
      },
      form: [ 'order' ]
    }
  }
}
</script>

<style>
h5 {
  font-weight: bold;
  font-family: inherit;
}
</style>
